<template>
  <div is="div" class="menu-mainnavigation-container" >
    <ul id="menu-mainnavigation" class="menu">
      <router-link
        v-for="route in myRoutes" 
        :key="route.ID"  tag="li" 
        :to="{ path: shortPath(route.url, route.target), params: { id: route.object_id } }" 
        class="nav-link"
        active-class="mucki"
        >
        <a >{{ route.title }}</a>
      </router-link>
      <li class="newsletterLink"><a class="mj-w-button-content" href="#" data-token="e2b4f3f3074e56638b0855122b6988ae" onclick="mjOpenPopin(event, this);jQuery('.menuopen').removeClass('menuopen');">Newsletter Sign Up</a></li>

    </ul>
  </div>  
</template>
<script>

  export default {
    name: 'MainNavigation',
    data: () => {
      return {
        myRoutes: {},
        mailjetNewsletter: '<li class="newsletterLink"><a class="mj-w-button-content" href="#" data-token="e2b4f3f3074e56638b0855122b6988ae" onclick="mjOpenPopin(event, this);jQuery(\'.menuopen\').removeClass(\'menuopen\');">Newsletter Sign Up</a></li>'
      }
    },
    mounted () {
      this.getMenu();
    },
    computed: {
    },
    methods: {
      shortPath: function(path, target){
        // if targetpath is has different URL than this
        let parser = document.createElement('a');
        parser.href = path;

        parser.protocol; // => "http:"
        parser.hostname; // => "example.com"
        parser.port;     // => "3000"
        parser.pathname; // => "/pathname/"
        parser.search;   // => "?search=test"
        parser.hash;     // => "#hash"
        parser.host;     // => "example.com:3000"
        //console.log(parser.host);
        if (parser.host!==this.globalHost) {
          let op='';
          if (target=="_blank") {
            op=`/blank/${path}`;
          } else {
            op=`/external/${path}`;
          }
          return op;
        }
        let url = path;
        let pathname = new URL(url).pathname;
        return pathname;
      },

      getMenu (){
        this.$http.get(
          '/menus/v1/menus/mainNavigation')
        .then( (response) => {
          //console.log(response);
          this.myRoutes = response.data.items;
        }).catch(function (error) {
          console.log(error);
        });
      }
    },

  };

</script>
<style lang="scss" scoped>
.router-link-exact-active {
 // outline: 1px solid #0f0;
 a {
   color: #F0C854;
 }
}
</style>
